
import Vue, { PropType } from 'vue';
import Icon, { Icon as IconName } from '@/common/icon/Icon.vue';
import { durationToHMS, durationToMS, nowUnixTimestamp } from '@/common/time';
import { Theme } from '@/side-bar/side-bar-config.interface';

export default Vue.extend({
    components: {
        Icon
    },

    props: {
        countdownEndTimestamp: {
            type: Number,
            required: true,
        },
        countdownDuration: {
            type: Number,
            required: true,
        },
        theme: {
            type: Object as PropType<Theme>,
            default: () => ({})
        }
    },

    data() {
        return {
            icon: IconName.clock,
            timeout: 0,
            timeLeft: 0
        };
    },

    computed: {
        readableTimeLeft(): string {
            if (this.countdownDuration >= 3600) {
                return durationToHMS(this.timeLeft);
            }
            return durationToMS(this.timeLeft);
        },
        shouldBlink():boolean {
            return this.timeLeft <= 5 && this.timeLeft > 0;
        },
        barWidth(): number {
            return Math.max(0, Math.min(100, Math.floor(100 * this.timeLeft / this.countdownDuration)));
        }
    },

    watch: {
        countdownEndTimestamp: {
            handler: function() {
                this.createTimeout();
            },
            immediate: true,
        }
    },

    beforeDestroy() {
        clearTimeout(this.timeout);
    },

    methods: {
        updateTimeLeft(): void {
            const now = nowUnixTimestamp();
            this.timeLeft = Math.max(Math.floor(this.countdownEndTimestamp) - now, 0);
        },

        createTimeout(): void {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.updateTimeLeft();
                if (this.timeLeft > 0) {
                    this.createTimeout();
                }
            }, 1000);
        }
    }
});
